import { ENV } from '@phi/config/frontend';
import { is_mobile } from '@phi/util/dom';
import { filter_ip } from '@vaaas/fpts/array';
import { reactive } from 'vue';

export type Point = {
    x: number;
    y: number;
    id: number;
}

export const touches_to_be_indicated = reactive([] as Point[]);

export const indicate_touch = (e: PointerEvent) => {
    disindicate_touch(e);
    touches_to_be_indicated.push(reactive({
        x: e.pageX,
        y: e.pageY,
        id: e.pointerId,
    }));
};

export const disindicate_touch = (e: PointerEvent) => {
    filter_ip((x: Point) => x.id !== e.pointerId)(touches_to_be_indicated);
};

export const should_indicate_touches = () => is_mobile() && ENV !== 'production';
